import type { ReactNode } from 'react';

export const symbol_local_pizza: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-840q97 0 187 32t167 89q12 9 18.5 21.95t6.5 26.67q0 8.38-2.5 16.84-2.5 8.45-7.5 16.54L530-156q-9 13.5-22.5 20.25T479.88-129q-14.12 0-27.5-6.5T430-156L111-637q-5.38-8.25-7.69-16.5Q101-661.75 101-670q0-13.85 6.5-26.92Q114-710 126-719q77-57 167-89t187-32Zm0 60q-92 0-168 31.5T159-671l321 484 321-484q-77-46-153.04-77.5Q571.91-780 480-780Zm-71 198.94q16-16.06 16-39T408.94-659q-16.06-16-39-16T331-658.94q-16 16.06-16 39T331.06-581q16.06 16 39 16T409-581.06Zm110 215q16-16.06 16-39T518.94-444q-16.06-16-39-16T441-443.94q-16 16.06-16 39T441.06-366q16.06 16 39 16T519-366.06ZM480-187Z"
		/>
	</svg>
);
